"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSON_EXTRACT = void 0;
exports.JSON_EXTRACT = {
    alias: 'EXT_JSON',
    description: 'Busca um campo no json, retornando seu valor',
    arg_names: ['json_em_string', 'json_path'],
    args_description: ['json a extrair campos', 'json_path'],
};
